module.exports = __webpack_public_path__ + "fonts/Manrope-Light.75136cd8.woff";